import type { IconData } from '@stacksjs/iconify-core'

export const basicUiLink: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14.047 1.953a6.667 6.667 0 0 1 0 9.428l-.803.803l-2.774-2.775l.712-.712a2.743 2.743 0 1 0-3.879-3.879l-.712.712l-2.775-2.774l.803-.803a6.667 6.667 0 0 1 9.428 0m-1.863 11.291L9.409 10.47l-.712.712a2.743 2.743 0 0 1-3.879-3.879l.712-.712l-2.774-2.775l-.803.803a6.667 6.667 0 1 0 9.428 9.428z\"/><path fill=\"currentColor\" d=\"M10.121 7.636a1.243 1.243 0 1 0-1.757-1.757L5.879 8.364a1.243 1.243 0 1 0 1.757 1.757z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiLink
